import { computed } from 'mobx';

/**
 * 상세모델
 * @window w_tb_e080w_03
 * @category 수신참조함
 */
export class ReferenceBoxDetailModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 출력
   *
   * **data type** varchar(1)
   */
  readonly prtchk: string;

  /**
   * 확인
   *
   * **data type** varchar(1)
   */
  readonly flag: string;

  /**
   * 문서
   *
   * **data type** varchar(3)
   */
  readonly papercd: string;

  /**
   * 작성일자
   *
   * **data type** varchar(8)
   */
  readonly repodate: string;

  /**
   * 작성자명
   *
   * **data type** varchar(10)
   */
  readonly repoperid: string;

  /**
   * 문서번호
   *
   * **data type** varchar(20)
   */
  readonly appnum: string;

  /**
   * 결재자
   *
   * **data type** varchar(10)
   */
  readonly appperid: string;

  /**
   * 부서명
   *
   * **data type** varchar(40)
   */
  readonly divinm: string;

  /**
   * 제목
   *
   * **data type** varchar(255)
   */
  readonly title: string;

  /**
   * 결재상태
   *
   * **data type** varchar(3)
   */
  readonly appgubun: string;

  /**
   * 순번
   *
   * **data type** varchar(3)
   */
  readonly seq: string;

  /**
   * 결재자명
   *
   * **data type** varchar(30)
   */
  readonly appernm: string;

  /**
   * 직위
   *
   * **data type** varchar(20)
   */
  readonly rspnm: string;

  /**
   * 수신참조확인
   *
   * **data type** varchar(1)
   */
  readonly referflag: string;

  /**
   * 결재일자
   *
   * **data type** varchar(8)
   */
  readonly appdate: string;

  /**
   * 사유
   *
   * **data type** varchar(0)
   */
  readonly remark: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.prtchk = data.prtchk || '';
    this.flag = data.flag || '';
    this.papercd = data.papercd || '';
    this.repodate = data.repodate || '';
    this.repoperid = data.repoperid || '';
    this.appnum = data.appnum || '';
    this.appperid = data.appperid || '';
    this.divinm = data.divinm || '';
    this.title = data.title || '';
    this.appgubun = data.appgubun || '';
    this.seq = data.seq || '';
    this.appernm = data.appernm || '';
    this.rspnm = data.rspnm || '';
    this.referflag = data.referflag || '';
    this.appdate = data.appdate || '';
    this.remark = data.remark || '';

    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
